import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const QuestionaryWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 4,

  "& span.answer": {
    font: "500 14px/16px Manrope",
    color: "#475467",
    textTransform: "capitalize",
  },
  "& span.question": {
    font: "600 14px/19.12px Manrope",
    color: "#0055A4",
  },
}));

export const SingleLineQuestionaryWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "5%",

  "@media (max-width: 959px)": {
    justifyContent: "space-between",
  },

  "& span.answer": {
    font: "500 14px/16px Manrope",
    color: "#475467",
    textTransform: "capitalize",
  },
  "& span.question": {
    font: "600 14px/19.12px Manrope",
    color: "#0055A4",
  },
}));

export const GridWrapper = styled(Grid)(() => ({
  borderBottom: "1px solid #CCDEEE",
  padding: "0.625rem 0",
  "@media screen and (max-width: 959px)": {
    borderBottom: "none",
  },
}));

interface SpacingInMobileProps {
  isMobile?: boolean;
  hasPaddingTop?: boolean;
  showInMobile?: boolean;
}
export const SpacingInMobile = styled(Grid, {
  shouldForwardProp: (props) =>
    !["hasPaddingTop", "isMobile", "showInMobile"].includes(props as string),
})(({ hasPaddingTop, showInMobile = true }: SpacingInMobileProps) => ({
  paddingTop: hasPaddingTop ? "0.625rem" : 0,
  borderBottom: "none",
  "@media screen and (max-width: 959px)": {
    borderBottom: "1px solid #ccdeee",
    display: showInMobile ? "block" : "none",
  },
}));

const styles = makeStyles(() => ({
  mainDiv: {
    marginTop: "30px",
  },
  title: {
    fontWeight: "bold",
  },
  value: {
    color: "#308cdb",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  checklistContent: {
    padding: "0px 10px",
  },
  lastContent: {
    paddingTop: "10px",
    paddingBottom: "0.5rem",
    "& span.answer": {
      font: "500 14px/16px Manrope",
      color: "#475467",
    },
    "& span.question": {
      font: "600 14px/19.12px Manrope",
      color: "#0055A4",
    },
  },
  itemContent: {
    borderBottom: "1px solid #CCDEEE",
    padding: "10px 0px",
    "&:nth-child(1)": {
      borderTop: "1px solid #CCDEEE",
      marginTop: "10px",
    },
  },
  accessCheckListWrapper: {
    border: "1px dashed #CCDEEE",
  },
}));

export default styles;
